if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.productId = this.getAttribute('product-id');
      this.boxIndex = 0;

      this.bundle = {};
      this.cartData = [];
      this.products = [];

      this.bundlePrice = 0;
      this.bundleDiscountType = '';
      this.bundleDiscount = 0;
    
      this.elProductCards = this.querySelectorAll('[data-product-card]');
      this.elProductCardVariants = this.querySelectorAll('[data-product-card] custom-select');
      this.elAdd = this.querySelectorAll('[data-bundle-add]');
      this.elBoxToggle = this.querySelector('[data-bundle-box-toggle]');
      this.elBoxClose = this.querySelector('[data-bundle-box-close]');
      this.elBox = this.querySelector('[data-bundle-box]');
      this.elCount = this.querySelector('[data-bundle-count]');
      this.elBoxProducts = this.querySelector('[data-bundle-products]');
      this.elBoxProductData = this.querySelectorAll('[data-bundle-data]');
      this.elStatus = this.querySelector('[data-bundle-status]');
      this.elSubmit = this.querySelector('[data-bundle-submit]');

      this.elProductCardVariants.forEach(el => el.addEventListener('change', this.updateProductCardVariant.bind(this)));
      this.elAdd.forEach(el => el.addEventListener('click', this.addProductToBox.bind(this)));
      this.elBoxToggle.addEventListener('click', this.toggleBoxProducts.bind(this));
      this.elBoxClose.addEventListener('click', this.toggleBoxProducts.bind(this));
      this.elSubmit.addEventListener('click', this.addBundleToCart.bind(this));

      this.setBundle();

      const toggleCollapsingBoxDesktop = () => {
        let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        isDesktop ? this.disableCollapsingBox() : this.enableCollapsingBox();
      }

      window.matchMedia('(min-width: 1024px)').matches && this.disableCollapsingBox();
      window.addEventListener('resize', toggleCollapsingBoxDesktop);
    }

    async fetchBundle() {
      const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ "productPlatformId": this.productId })
      });

      const data = await response.json();
      return data;
    }

    setBundle() {
      this.fetchBundle()
        .then(response => {
          if(!response.ok) {
            this.style.display = 'none';
            return;
          } else {
            this.bundle = response.DynamicBox;
            this.setBoxIndex();
            this.setBundleDiscount();
            this.enableAddToCart();
          }
        })
        .catch(err => {
          console.log(err);
          this.style.display = 'none';
        })
    }

    setBoxIndex() {
      const cartBundleItems = window.cart.items.filter(item => !!item.properties['_dynamicBoxId']);
      if(cartBundleItems.length) {
        const boxIndexes = cartBundleItems.map(item => item.properties._dynamicBoxIndex);
        const highestIndex = Math.max(boxIndexes);
        this.boxIndex = highestIndex + 1;
      }
    }

    setBundleDiscount() {
      this.bundleDiscountType = this.bundle.fixedDiscountTier ? 'amount' : this.bundle.percentDiscountTier ? 'percent' : null;
      if(this.bundleDiscountType) {
        const discountRange = this.bundle.fixedDiscountTier ? this.bundle.fixedDiscountTier : this.bundle.percentDiscountTier;  
        const thresholds = Object.keys(discountRange);
        const currentThreshold = this.bundle.sizeRange ? this.products.length : this.bundlePrice;

        let currentDiscount = 0;

        thresholds.forEach((threshold, index) => {
          Number(currentThreshold) >= Number(threshold) && (currentDiscount = Number(discountRange[threshold]));
        })

        this.bundleDiscount = currentDiscount;
        this.updateProductCardPrices();
      }
    }

    priceWithDiscount(price) {
      return this.bundleDiscount ? this.bundleDiscountType == 'percent' ? price - (price * (this.bundleDiscount / 100)) : price - (this.bundleDiscount * 100) : price;
    } 

    enableAddToCart() {
      const canAddToCart = this.bundle.sizeRange ? this.products.length >= this.bundle.sizeRange[0] : this.bundle.priceRange ? this.bundlePrice >= this.bundle.priceRange.min * 100 : true;
      const priceWithDiscount = this.priceWithDiscount(this.bundlePrice);
      
      this.elSubmit.toggleAttribute('disabled', !canAddToCart);
      this.elSubmit.innerHTML = canAddToCart ? `Add Bundle To Cart ${this.bundlePrice > priceWithDiscount ? `<s>${formatMoney(this.bundlePrice, 0)}</s>` : ''}<strong>${formatMoney(priceWithDiscount, 0)}</strong>` : 'Select More Products';
    }

    addProductToBox(ev) {
      ev.preventDefault();
      const elProduct = ev.currentTarget.closest('.product-card');
      const elVariant = elProduct.querySelector('input:checked');
      const elData = elProduct.querySelector('[data-bundle-data]');

      const variantId = Number(elVariant.value);
      const bundleData = JSON.parse(elData.innerHTML);
      const variantPrice = bundleData.variants[variantId].price;

      const canAddProduct = this.bundleSizeRange ? this.products.length + 1 < this.bundle.sizeRange[1] : this.bundle.priceRange ? Number(this.bundlePrice) + Number(variantPrice) < this.bundle.priceRange.max * 100 : true;

      if(canAddProduct) {
        const existingCartItem = this.cartData.find(variant => variant.id == variantId);

        const cartData = {
          id: variantId,
          quantity: 1,
          properties: {
            _dynamicBoxIndex: this.boxIndex,
            _dynamicBoxId: this.bundle.boxId,
          }
        }

        existingCartItem ? existingCartItem.quantity++ : this.cartData.push(cartData);
        this.products.push({ id: variantId, product: bundleData });
        this.bundlePrice = Number(this.bundlePrice) + Number(variantPrice);
        this.setBundleDiscount();
        this.renderBoxProducts(); 
        console.log(this.cartData);
      } 
    }

    removeProductFromBox({ currentTarget: elButton }) {
      const variantId = Number(elButton.getAttribute('data-bundle-remove'));
      const productIndexToRemove = this.products.map(item => item.id).indexOf(variantId);
      const cartItemIndexToRemove = this.cartData.map(item => item.id == variantId);
      const variantPrice = this.products[productIndexToRemove].product.variants[variantId].price;

      this.products.splice(productIndexToRemove, 1);
      this.cartData.splice(cartItemIndexToRemove, 1);
      this.bundlePrice = Number(this.bundlePrice) - Number(variantPrice);
      this.setBundleDiscount();
      this.renderBoxProducts();
    }

    renderBoxProducts() {
      this.elBoxProducts.innerHTML = this.products.map(({ id, product }) => {
        const productPrice = product.variants[id].price;
        const discountedPrice = this.priceWithDiscount(productPrice);
        
        return `
          <div class="bundle-builder--box-product group overlay-link--parent" data-bundle-product>
            <span class="bundle-builder--box-product-remove btn--close"></span>
            <button
              type="button"
              class="overlay-link"
              data-bundle-remove="${id}"
            >
              <span class="visually-hidden">Remove variant #${id} from bundle</span>
            </button>
            <div class="bundle-builder--box-product-image">
              ${product.image}
            </div>
            <div class="bundle-builder--box-product-info">
              <h4 class="bundle-builder--box-product-title">
                ${product.title}
              </h4>
              ${product.variants[id].title ? `
                <div class="bundle-builder--box-product-variant">
                  ${product.variants[id].title}
                </div>`: ''
              }
              <div class="bundle-builder--box-product-price">
                ${productPrice > discountedPrice ? `<s>${formatMoney(productPrice)}</s> ${formatMoney(discountedPrice)}` : formatMoney(discountedPrice)}
              </div>
            </div>
          </div>
        `
      }).join('');

      const elRemove = document.querySelectorAll('[data-bundle-remove]')
      elRemove.forEach(el => el.addEventListener('click', this.removeProductFromBox.bind(this)));
      
      window.initLazyLoad();
      this.enableAddToCart();
      
      this.classList.toggle('has-items', this.products.length);
      this.elCount.innerHTML = this.products.length ? `(${this.products.length})` : '';
    }

    addBundleToCart(ev) {
      ev.preventDefault();
      this.classList.add("adding");
      this.elStatus.innerHTML = `<span>Adding <span class="visually-hidden">to cart</span>...</span>`;
      this.elSubmit.disabled = true;
      console.log({ items: this.cartData })
      window.addToCart({ items: this.cartData })
        .then((response) => {
          this.classList.remove("adding");
          if (response.status) {
            this.classList.add("error");
            this.elStatus.innerHTML = `<span>Error<span class="visually-hidden"> adding to cart</span></span>`;
          } else {
            this.classList.add("success");
            this.elStatus.innerHTML = `<span>Added to cart</span>`;
          }
          setTimeout(() => this.resetButtonState(), 5000);
        });
    }

    resetButtonState() {
      this.classList.remove("error");
      this.classList.remove("success");
      this.enableAddToCart();
      this.boxIndex = this.boxIndex + 1;
      setTimeout(() => {
        this.elStatus.innerHTML = "";
      }, 300);
    }

    updateProductCardPrices() {
      this.elProductCards.forEach(el => {
        const elPrice = el.querySelector('[data-price]');
        const { price } = elPrice.dataset;
        this.updateProductCardPrice(elPrice, price);
      });
    }

    updateProductCardPrice(elPrice, price) {
      if(this.bundleDiscount > 0) {
        const priceWithDiscount = this.priceWithDiscount(Number(price));
        elPrice.innerHTML = `<s>${formatMoney(Number(price))}</s> ${formatMoney(priceWithDiscount)}`
      } else {
        elPrice.innerHTML = formatMoney(Number(price));
      }
    }

    updateProductCardVariant({ target: elVariant }) {
      const elProduct = elVariant.closest('[data-product-card]');
      const elPrice = elProduct.querySelector('[data-price]');
      const elData = elProduct.querySelector('[data-bundle-data]');

      const data = JSON.parse(elData.innerHTML);
      const { value: variantId } = elVariant;
      const variant = data.variants[variantId];

      elPrice.setAttribute('data-price', variant.price);
      this.updateProductCardPrice(elPrice, variant.price);
    }

    toggleBoxProducts() {
      const isOpen = this.elBox.classList.contains('open');
      if(isOpen) {
        this.elBoxToggle.classList.remove('open');
        this.elBoxToggle.innerHTML = `Show items <span class="btn--chevron"></span>`
        this.elBox.classList.remove('open');
        this.elBoxToggle.setAttribute('aria-expanded', false);
        this.elBoxProducts.parentNode.setAttribute('aria-hidden', true);
        setTimeout(() => {
          this.elBox.classList.remove('visible');
        }, 300)
      } else {
        this.elBox.classList.add('visible');
        setTimeout(() => {
          this.elBoxToggle.classList.add('open');
          this.elBoxToggle.innerHTML = `Hide items <span class="btn--chevron"></span>`
          this.elBox.classList.add('open');
          this.elBoxToggle.setAttribute('aria-expanded', true);
          this.elBoxProducts.parentNode.setAttribute('aria-hidden', false);
        }, 50);
      }
    }

    disableCollapsingBox() {
      this.collapsingBoxEnabled = false;
      this.elBoxToggle.disabled = true;
      this.elBoxToggle.innerHTML = `Hide items <span class="btn--chevron"></span>`;
      this.elBoxToggle.classList.add('open');
      this.elBox.classList.add('open');
      this.elBox.classList.add('visible');
      this.elBoxToggle.setAttribute('aria-expanded', true);
      this.elBoxProducts.parentNode.setAttribute('aria-hidden', false);
    }

    enableCollapsingBox() {
      this.collapsingBoxEnabled = true;
      this.elBoxToggle.disabled = false;
      this.elBoxToggle.innerHTML = `Show items <span class="btn--chevron"></span>`;
      this.elBoxToggle.classList.remove('open');
      this.elBox.classList.remove('open');
      this.elBox.classList.remove('visible');
      this.elBoxToggle.setAttribute('aria-expanded', false);
      this.elBoxProducts.parentNode.setAttribute('aria-hidden', true);
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
}